/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-eval */
import { ApiKeyFetch } from "api/fetchers/apiKey";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { HideField } from "components/InputsMex/inputs";
import Page from "components/Page";
import {
  ambienteAplicacion,
} from "constants/urls";
import { URLS_PHP_8 } from "constants/urls_v2";
import { Button as BtnPrime } from "primereact/button";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS, PRODUCTOS } from "utils/constants";
import Loading from "wrappers/Loading";
import {
  DropDownFilter,
  SimpleCheckBoxFlex,
  TextInput,
} from "../../componentes/entradas";
import { Hogar } from "../../constantes/general";
import DatosVivienda from "./components/DatosVivienda";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

export const FlexibleCoberturas = ({
  history,
  params: { idCotizacion },
  dataUsuario: { cliCodigoCore, userIsLoggedIn },
  addWarningToast,
}) => {
  const [loading, setLoading] = useState(true);

  const [medidasSeguridad, setMedidasSeguridad] = useState([]);
  //ESTE CODIGO SE ACTIVARA A PETICION DE AIG const [datosVivienda, setDatosVivienda] = useState([]);
  const [datosVivienda, setDatosVivienda] = useState([]);
  const [cobertura, setCobertura] = useState([]);
  const methods = useForm({
    mode: "onChange",
  });

  const { handleSubmit, reset } = methods;
  useEffect(() => {
    const getData = async () => {
      const Data = {
        ambiente: ambienteAplicacion,
        prodCodigo: Hogar.codProducto,
        prodCodigoCore: Hogar.prodCodigoCore,
        pasoCodigo: "informacionCliente",
        datosCotizador: {
          idCotizacion: idCotizacion || "",
          prodCodigo: Hogar.codProducto,
          cotPasoCodigo: {
            descripcion: "cotizadorCoberturas",
            parCodigo: "hogarFlexCoberturasCotizador",
          },
          usuCotiza: {
            usuCodigo: cliCodigoCore || "",
          },
        },
      };

      const res = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.catalogosCotizador, Data);
      console.log("RES: ", res);

      if (res?.transaccion) {
        setMedidasSeguridad(res?.catalogo?.medidaSeguridad);
        //ESTE CODIGO SE ACTIVARA A PETICION DE AIG 
        setDatosVivienda(res?.catalogo?.datosVivienda);

        setCobertura(res.catalogo.coberturas);
        const objCoberturas = {};
        res.catalogo.coberturas.forEach(
          (input) => (objCoberturas[input.name] = input.value)
        );
        methods.reset({
          coberturas: {
            ...objCoberturas,
          },
        });
      }
      setLoading(false);
    };

    if (userIsLoggedIn) {
      getData();
    } else {
      history.push("/");
    }
  }, []);

  const onSubmit = async (values) => {
    reset({ ...values });
    const { incendio, robo, datosVivienda: dataVivienda, coberturas } = values;

    setLoading(true);

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: Hogar.codProducto,
      prodCodigoCore: "hogarCotizadorFlex",
      proTipoPlan: Hogar.proTipoPlan,
      pasoCodigo: "guardarInformacion",
      items: {
        cotCodigo: idCotizacion || "",
        medidasSeguridad: { robo, incendio },
        datosVivienda: dataVivienda,
        coberturas,
        cotPasoCodigo: {
          descripcion: "cotizadorCoberturas",
          parCodigo: "hogarFlexCoberturasCotizador",
        },
        usuCotiza: { usuCodigo: cliCodigoCore || "" },
      },
    };

    console.log("DATA: ", Data);
    const res = await ApiKeyFetch.instance().post(URLS_PHP_8.cotizacion.actualizarCotizacion, Data);

    if (res?.transaccion === true && res?.id) {
      if (userIsLoggedIn) {
        history.push(`/hogar3/${res?.id}`);
      } else {
        history.push(`/`);
      }
    } else {
      try {
        res.errorDescripcion.forEach((msg) =>
          addWarningToast(msg, { autoDismiss: false })
        );
      } catch (e) {
        addWarningToast("Error desconocido", { autoDismiss: false });
      }
    }
    console.log(res);
    setLoading(false);
  };

  const onSubmitError = () => {
    addWarningToast("Por favor rellene toda la información necesaria");
  };

  const handleRegresar = () => {
    history.push(`${Hogar.urls.individualFlexible1}/${idCotizacion}`);
  };

  const obtenerToolTip = (limites) => {
    const maxValue = getMaxMinValue(limites?.maxFormula, limites?.max, "max");

    const minValue = getMaxMinValue(limites.minFormula, limites?.min, "min");

    return `Valor máximo ${formatter.format(
      maxValue()
    )} \n Valor mínimo ${formatter.format(minValue())}`;
  };

  const parsearFormula = (formula, value = []) => {
    let resp;
    const regex = /{([^}]*)}/g;
    while ((resp = regex.exec(formula)) !== null) {
      formula = formula.replace(
        `{${resp[1]}}`,
        `(methods.watch('coberturas.${resp[1]}') * 1 || ${value[0]} || 0)`
      );
    }
    return formula;
  };

  const getMaxMinValue = (formula, value = 0, type = "max") => {
    if (isNaN(formula * 1)) {
      const condicion = formula.includes("||") || formula.includes("&&");
      formula = formula.replace("||", ",");
      formula = formula.replace("&&", ",");
      formula = parsearFormula(formula, value);
      if (condicion) {
        formula = `Math.${type}(${formula.trim()})`;
      }
      const func = eval(`()=>{return ${formula}}`);
      return func;
    } else {
      return () => {
        return formula;
      };
    }
  };

  const validarLimites = ({ limites, required }, value) => {
    const max = getMaxMinValue(limites?.maxFormula, limites?.max, "max")();
    const min = getMaxMinValue(limites?.minFormula, limites?.min, "min")();

    if (
      (value * 1 <= Number(max).toFixed(2) && value * 1 >= Number(min).toFixed(2)) ||
      value * 1 === 0
    ) {
      return required && value * 1 === 0 ? "El valor no puede ser cero" : true;
    }
    return `Ingrese un valor entre ${formatter.format(min)} y ${formatter.format(max)}`;
  };

  const validarDependencias = (formula, name) => {
    try {
      const func = eval(`()=>(${parsearFormula(formula)})`);
      return () => {
        const value = func();
        const internalValue = methods.watch(`coberturas.${name}`);
        if (internalValue && name && value === false) {
          methods.setValue(`coberturas.${name}`, 0, { shouldValidate: true });
        }
        return value;
      };
    } catch (error) {
      console.log(error);
      return true;
    }
  };

  const validarValorDefecto = (valor) => {
    if (valor == 0) {
      return "";
    }
    return valor;
  }

  const showMinPlaceHolder = (limites) => {
    const minValue = getMaxMinValue(limites.minFormula, limites?.min, "min");
    return formatter.format(minValue());
  }

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumbPasosCotizacionHogarFlex[3]}
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]?.pasosHogarFlex}
          />

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit, onSubmitError)}>
              <div className='row justify-content-center mx-2'>
                <div className='col-12 text-center mt-3'>
                  <h2>{medidasSeguridad?.seccion || "Medidas de Seguridad"}</h2>
                </div>
                {medidasSeguridad?.campos?.map?.(({ label, options, name }) => (
                  <div
                    key={name}
                    className='col-11 col-xl-10 d-flex flex-wrap justify-content-start p-1 bg-whitesmoke py-2'>
                    <div className=' col-12 mb-3'>
                      <h3 className='py-3 font-20px'>{label}</h3>
                    </div>
                    {options?.map?.((input) => {
                      return (
                        <div key={input.name} className='col-lg-3 col-md-4 col-sm-6'>
                          <SimpleCheckBoxFlex
                            name={`${name}.${input.name}.check`}
                            fontSize='1.5rem'
                            label={input.label}
                            defaultValue={input?.value?.check || false}
                          />
                          <HideField
                            name={`${name}.${input.name}.descuento`}
                            defaultValue={input?.value?.descuento}
                          />
                          <HideField
                            name={`${name}.${input.name}.label`}
                            defaultValue={input?.label}
                          />
                          <HideField
                            name={`${name}.${input.name}.name`}
                            defaultValue={input?.name}
                          />
                          {/* <SimpleCheckBox
                            label={input.label}
                            name={`${name}.${input.name}`}
                          /> */}
                        </div>
                      );
                    })}
                  </div>
                ))}
                <DatosVivienda {...datosVivienda} />

                <div className='col-11 col-xl-10 bg-lightblue color-mex p-3'>
                  <h2>Coberturas</h2>
                </div>
                <div className='col-11 col-xl-10 d-flex flex-wrap justify-content-around border p-5'>
                  {cobertura?.map((input, index) => {
                    return (
                      <React.Fragment key={`${input.name}${index}`}>
                        <div className='d-flex col-md-6 col-lg-8 col-xl-7 mt-3'>
                          <div
                            className='form-group w-100 p-1'
                            style={{ borderBottom: "solid 1px whitesmoke" }}>
                            <p className='font-17px'>
                              {input.label}
                              {input?.type !== "select" && (
                                <BtnPrime
                                  type='button'
                                  style={{ borderRadius: "25%" }}
                                  className='p-button-text p-button-plain p-0 font-16px p-button-sm'
                                  tooltip={obtenerToolTip(input?.limites)}
                                  icon='pi pi-question-circle'
                                />
                              )}
                            </p>
                          </div>
                        </div>
                        <div className='col-md-6 col-lg-4 col-xl-3'>
                          {input?.type !== "select" && (
                            <SimpleContainer
                              name={`coberturas.${input.name}`}
                              helpText={
                                !validarDependencias(input?.dependent?.validation)() &&
                                input?.dependent.message
                              }>
                              <TextInput
                                inputProps={{
                                  name: `coberturas.${input.name}`,
                                  type: input.type,
                                }}
                                extrasClasses='hide-arrows pr-3'
                                disabled={
                                  !validarDependencias(
                                    input?.dependent.validation,
                                    input.name
                                  )()
                                }
                                defaultValue={input?.value}
                                evaluateDefaultValue={validarValorDefecto}
                                evaluateValue={validarValorDefecto}
                                customPlaceHolder={showMinPlaceHolder(input?.limites)}
                                prefix='$  '
                                rules={{
                                  required: true,
                                  validate: (value) => validarLimites(input, value),
                                }}
                                numerico={true}
                                align='right'
                              />
                            </SimpleContainer>
                          )}
                          {input?.type === "select" && (
                            <SimpleContainer name={`coberturas.${input.name}`}>
                              <DropDownFilter
                                defaultValue={input?.value}
                                name={`coberturas.${input.name}`}
                                options={input.options}
                                placeHolder={"Seleccionar"}
                              />
                            </SimpleContainer>
                          )}
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
              <div className='row justify-content-center my-5'>
                <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
                  <button
                    className='btn btn-atras-api'
                    type='button'
                    onClick={handleRegresar}>
                    Atrás
                  </button>
                </div>
                <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
                  <button className='btn btn-siguiente-api' type='submit'>
                    Continuar
                  </button>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
